'use client';
import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchFilterBarProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
}

export default function SearchFilterBar({ searchQuery, onSearchChange }: SearchFilterBarProps) {
  return (
    <div className="relative w-full">
      <Search
        size={16}
        className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[rgb(113,113,133)] pointer-events-none"
      />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search channels, radio stations, events by name or country..."
        className="w-full bg-[rgb(18,18,22)] border border-[rgb(39,39,48)] text-sm text-white placeholder-[rgb(113,113,133)] rounded-xl pl-10 pr-10 py-3 focus:outline-none focus:border-[rgb(232,82,26)] transition-colors"
      />
      {searchQuery && (
        <button
          onClick={() => onSearchChange('')}
          className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[rgb(113,113,133)] hover:text-white transition-colors"
          aria-label="Clear search"
        >
          <X size={15} />
        </button>
      )}
    </div>
  );
}
